import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';

const Context = React.createContext({});

const FindingContextProvider = (props) => {
  const [clickedFinding, setClickedFinding] = useState();

  return <Context.Provider value={{ clickedFinding, setClickedFinding }}>{props.children}</Context.Provider>;
};

FindingContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

FindingContextProvider.defaultProps = {};

export default React.memo(FindingContextProvider);

export const useFindingContext = () => useContext(Context);
